import React from "react";
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";

const RewardCard = ({ reward, canAfford, onRedeem }) => (
  <div className="bg-card border border-border rounded-xl overflow-hidden hover:shadow-lg transition-shadow flex flex-col" data-testid={`reward-card-${reward.reward_id}`}>
    <div className="relative h-36 bg-secondary/40">
      {reward.image_url && <img src={reward.image_url} alt={reward.title} className="w-full h-full object-cover" />}
      {reward.featured && <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full text-[10px] font-bold bg-primary text-primary-foreground tracking-widest">FEATURED</span>}
      <span className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[11px] font-bold bg-background/90 text-foreground border border-border">
        <Sparkles className="w-3 h-3" /> {reward.karma_cost}
      </span>
    </div>
    <div className="p-4 flex-1 flex flex-col">
      <div className="text-[11px] uppercase tracking-widest text-muted-foreground font-semibold">{reward.partner_name} · {reward.category}</div>
      <div className="mt-1 font-display font-semibold">{reward.title}</div>
      <p className="mt-1 text-sm text-muted-foreground line-clamp-2 flex-1">{reward.description}</p>
      <Button
        onClick={() => onRedeem(reward)}
        disabled={!canAfford}
        className="mt-3 w-full"
        data-testid={`redeem-btn-${reward.reward_id}`}
      >
        {canAfford ? "Redeem" : `Need ${reward.karma_cost}`}
      </Button>
    </div>
  </div>
);

export default RewardCard;
